import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import CircleAvatar from '@components/lpc/Navbar/CircleAvatar/CircleAvatar';
import { AvatarType } from '@propTypes/userTypes';

import css from './ParticipationBadge.module.scss';

type ParticipationBadgeProps = {
    avatar: AvatarType;
    firstName: string;
    lastName: string;
};

const ParticipationBadge = ({ avatar, firstName, lastName }: ParticipationBadgeProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);

    return (
        <div className={css.badge}>
            <div
                className={css.badge__avatar}
                style={{
                    backgroundImage: `url(${avatar})`,
                }}
            />
            <CircleAvatar avatar={avatar} height={'35px'} width={'35px'} />
            <Text customClass={css.badge__name} variant={'caption_01'} color={'txt-primary'}>
                {firstName} {lastName}
            </Text>
            <Text variant={'caption_01'} color={'brand-primary'}>
                {t('activity.has-participated')}
            </Text>
        </div>
    );
};

export default ParticipationBadge;
